<section class="listing-summary" [class.luxury]="listing.isLuxury" [class.commercial]="listing.isCommercial">
  <nav class="navigation is-flex has-flex-align-center">
    <app-back-button [img]="'/assets/icons/general_navigation/Back_to_search_blue.svg'"></app-back-button>
    <span class="flex-one change-listings" *ngIf="hasNextListings">
      <span class="flex-one is-flex" style="justify-content: flex-end;">
        <a class="is-flex has-flex-align-center no-select" tabindex="0" (click)="previousListingClicked.emit($event)"
           (keydown.enter)="previousListingClicked.emit($event)">
          <i class="material-icons">chevron_left</i>
          {{ 'navigation.previous' | translate }}
        </a>
        <span class="is-flex" style="margin-left: 10px; margin-right: 10px;">|</span>
        <a class="is-flex has-flex-align-center no-select" tabindex="0" (click)="nextListingClicked.emit($event)"
           (keydown.enter)="nextListingClicked.emit($event)">
          {{ 'navigation.next' | translate }}
          <i class="material-icons">chevron_right</i>
        </a>
      </span>
    </span>
  </nav>
  <div [ngClass]="{'courtesy': !isEdmontonBoard, 'dark-courtesy': isEdmontonBoard}" *ngIf="listing.isLuxury">{{listing | courtesyMessage: isEdmontonBoard}}
    <div class="mlsNumber">
      <span>{{ 'details.mls-num' | translate }}: </span>
      <span>{{ listing.mlsNum ? listing.mlsNum : ('na' | translate) }}</span>
    </div>
  </div>
  <div [class.listing-highlights]="listing.isLuxury" [class.listing-highlights--redesign]="!listing.isLuxury">
    <div class="listing-highlights__container">
      <header class="is-flex">
        <img class="listing-summary__remax-ballon" *ngIf="!listing.isCommercial && !listing.isLuxury"
                  src="{{'/assets/BalloonLarge.svg' | staticp}}" [alt]="'aria.logo' | translate"/>
        <div class="flex-one">
          <h1 class="address">{{ listing.address }}</h1>
          <div class="address-supplementary">
            <app-listing-address
              [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
          </div>
          <div class="listing-highlights__bottom-row" *ngIf="!listing.isOffMarket">
            <div class="mlsNumber">
              <span>{{ 'details.mls-num' | translate }}: </span>
              <span>{{ listing.mlsNum ? listing.mlsNum : ('na' | translate) }}</span>
            </div>
            <span [ngClass]="{'courtesy': !isEdmontonBoard, 'dark-courtesy': isEdmontonBoard}" *ngIf="!isCaraBoard">{{listing | courtesyMessage: isEdmontonBoard}}</span>
         </div>
        </div>
      </header>
      <app-listing-summary-desktop-content [listing]="listing"
                                          [sessionEmail]="sessionEmail"
                                          (toggleExpandedGalleryView)="toggleExpandedGalleryView.emit($event)"
                                          [currentSlideIndex]="currentSlideIndex"
                                          [showMap]="showMap"
                                          [forceLuxuryStyle]="true"
                                          (toggleMap)="toggleMap.emit()"
                                          [isMortgageApplicable]="isMortgageApplicable"
                                          [mortgagePaymentAmount]="mortgagePaymentAmount"
                                          [disableSellersLeadForm]="disableSellersLeadForm"
                                          (homeEstimateLinkClick)="homeEstimateLinkClick.emit($event)"
                                          (showContactAgentClicked)="showContactAgentClicked.emit($event)"
                                          (showOffmarketCTAClicked)="showOffmarketCTAClicked.emit($event)"
                                          (showScheduleViewingClicked)="showScheduleViewingClicked.emit($event)"
                                          (changeCarouselIndex)="changeCarouselIndex($event)"
      >

        <ng-container *ngIf="isVictoriaRealEstateBoard">
          <a href="https://vreb.org/vreb-idx-reciprocity-program" target="_blank">
            <img src="../../../../assets/icons/VREBReciprocityLogo.png" height="48" width="95" class="vreb-logo"/>
          </a>
        </ng-container>

        <ng-container *ngIf="isCaraBoard">

            <img src="../../../../assets/icons/CaraIcon.png"  class="vreb-logo"/>

        </ng-container>

      </app-listing-summary-desktop-content>
      <div class="is-flex footer-container" *ngIf="listing.isLuxury">
        <footer #imageContainer>
          <div class="image-container" *ngFor="let imageUrl of listing.imageUrls; let i=index"
              [class.selected]="currentSlideIndex === i">
            <img appImgIxImage [url]="imageUrl" [attr.data-src]="imageUrl" appImgLoader
                [fallbackImageUrl]="listing.placeHolderImage"
                [class.lazyload]="listing.isLuxury || (i <= (currentSlideIndex + 3)) || (i > (listing.imageUrls.length - 2))"
                [alt]="('gallery.aria.listingPhoto' | translate ) + ' ' + i" (click)="toggleImage(i)">
          </div>
        </footer>
        <div class="luxury-more-to-see is-flex">
            <a
              (click)="toggleMap.emit()"
              role="button"
              (keydown.enter)="toggleMap.emit()">
              <p [class.selected]="showMap">
                {{'details.map' | translate | uppercase }}
              </p>
            </a>
            <a [attr.href]="listing.videoUrl"
               target="_blank"
               rel="noopener">
               <p [class.inactive]="!listing.videoUrl">
                {{'details.video' | translate | uppercase }}
               </p>
            </a>
            <a [attr.href]="listing.virtualTourUrl"
                target="_blank"
                rel="noopener">
                <p [class.inactive]="!listing.virtualTourUrl">
                  {{'details.virtual-tour' | translate | uppercase }}
                </p>
            </a>
          </div>
      </div>
    </div>
  </div>
  <app-modal [shouldShowModal]="showExpandedGalleryView" (closeModal)="toggleExpandedGalleryView.emit(false)"
             [templateRef]="expandedGalleryRef" [isReDesign]="!listing.isLuxury">
  </app-modal>
  <ng-template #expandedGalleryRef>
    <header class="listing-expanded" *ngIf="!listing.isLuxury">
      <div class="listing-expanded__left-container">
        <img class="listing-summary__remax-ballon" *ngIf="!listing.isCommercial"
          src="{{'/assets/BalloonLarge.svg' | staticp}}" [alt]="'aria.logo' | translate"/>
        <div class="listing-expanded__address-container">
            <div class="text-left street-address address">
            {{listing.address.toLowerCase()}}
            <br *ngIf="!listing.address">
          </div>
          <div class="area-address address-supplementary">
            {{listing.city}}
              <app-listing-address
                [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
          </div>
          <div class="listing-highlights__bottom-row">
              <div class="mlsNumber">
                <span>{{ 'details.mls-num' | translate }}: </span>
                <span>{{ listing.mlsNum ? listing.mlsNum : ('na' | translate) }}</span>
              </div>
              <span [ngClass]="{'courtesy': !isEdmontonBoard, 'dark-courtesy': isEdmontonBoard}"  *ngIf="!isCaraBoard">{{listing | courtesyMessage: isEdmontonBoard}}</span>
           </div>
        </div>
      </div>
      <div class="listing-expanded__right-container">
        <div class="listing-expanded__right-container__button-container">
          <div class="btn-redesign btn-redesign--secondary favourites is-flex has-flex-align-center" [class.commercial]="listing.isCommercial"
                (click)="toggleFavourite($event)" role="button" tabindex="0" (keydown.enter)="toggleFavourite($event)">
            <img class="no-hover" [src]="('/assets/icons/heart/heart_icon' + (listing.isCommercial ? '_commercial' : '') + (listing.isFavourite ? '_red.svg' : '.svg')) | staticp" height="17" width="18"
              [alt]="('listing-summary.' + (listing.isFavourite ? 'remove-from' : 'save') + '-saved-listings' ) | translate" style="margin-right:5px;"
              />
            <img class="hover" [src]="('/assets/icons/heart/heart_icon-white.svg') | staticp" height="17" width="18"
              [alt]="('listing-summary.' + (listing.isFavourite ? 'remove-from' : 'save') + '-saved-listings' ) | translate" style="margin-right:5px;"
            />
            <a
                [translate]="listing.isFavourite ? 'listing-summary.saved-saved-listings' : 'listing-summary.save-saved-listings'"></a>
          </div>
        </div>
        <span class="btn-redesign btn-redesign--primary btn-redesign--large" [class.commercial]="listing.isCommercial" translate="contact.request-more-info"
        (click)="navigateToForm()" role="button" tabindex="0" (keydown.enter)="navigateToForm()"></span>
      </div>
    </header>
    <header *ngIf="listing.isLuxury">
      <div class="text-left street-address">
        {{listing.address}}
        <br *ngIf="!listing.address">
      </div>
      <div class="is-flex has-flex-align-center" style="margin-right: 10px;">
        <div class="flex-one area-address" style="flex: 1;">
          <app-listing-address
            [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]"></app-listing-address>
        </div>

        <div class="flex-one is-flex has-flex-content-end has-flex-align-center">
          <div class="listing-expanded__right-container__button-container">
            <div class="btn-redesign btn-redesign--secondary favourites is-flex has-flex-align-center"
                  (click)="toggleFavourite($event)" role="button" tabindex="0" (keydown.enter)="toggleFavourite($event)">
              <img class="no-hover" [src]="('/assets/icons/heart/heart_icon' + (listing.isFavourite ? '_red.svg' : '.svg')) | staticp" height="17" width="18"
                [alt]="('listing-summary.' + (listing.isFavourite ? 'remove-from' : 'save') + '-saved-listings' ) | translate" style="margin-right:5px;"
                />
              <img class="hover" [src]="('/assets/icons/heart/heart_icon-white.svg') | staticp" height="17" width="18"
                [alt]="('listing-summary.' + (listing.isFavourite ? 'remove-from' : 'save') + '-saved-listings' ) | translate" style="margin-right:5px;"
              />
              <a
                  [translate]="listing.isFavourite ? 'listing-summary.saved-saved-listings' : 'listing-summary.save-saved-listings'"></a>
            </div>
            <span class="btn-redesign btn-redesign--primary btn-redesign--large" translate="contact.request-more-info"
            (click)="navigateToForm()" role="button" tabindex="0" (keydown.enter)="navigateToForm()"></span>
          </div>
        </div>
      </div>
    </header>
    <app-rm-carousel [images]="listing.imageUrls" [showHighDprImages]="false"
                     (onChangeCarouselIndex)="currentSlideIndex = $event" [isCommercial]="listing.isCommercial"
                     [isLuxury]="listing.isLuxury" [imageQualityPercentage]="100"
                     [currentSlideIndex]="currentSlideIndex" carouselParentName="expanded-view"></app-rm-carousel>
  </ng-template>
  <div class="listing-summary__line separated"></div>
</section>
